const $ = jQuery.noConflict();

class MenuMobile {
    constructor() {
        this.header = $('.main-header');
        this.menuItems = this.header.find('.main-header__main-nav-mobile > ul > li > a');
        this.megaMenu = this.menuItems.next('.mega-menu');

        // Variables
        this.time = 200;
    }

    init() {
        this.menuItems.on('click', this.toggleMegaMenu.bind(this));
    }

    toggleMegaMenu(e) {
        const item = $(e.delegateTarget);
        const megaMenu = item.next('.mega-menu');

        if (!megaMenu.length) {
            return;
        }

        e.preventDefault();
        if (megaMenu.hasClass('active')) {
            this.hideMegaMenu();
            return;
        }
        this.hideMegaMenu();
        this.showMegaMenu(item, megaMenu);
    }

    showMegaMenu(item, megaMenu) {
        item.addClass('active');
        megaMenu.addClass('active').stop().slideDown(this.time);
    }

    hideMegaMenu() {
        this.menuItems.removeClass('active');
        this.megaMenu.removeClass('active').stop().slideUp(this.time);
    }
}

export default new MenuMobile();
